export const sx = {
    root: {
        height: '100%',
        overflowY: 'auto',
        // Same as the legacy menu: the labels get the full 100px.
        scrollbarWidth: 'none',
        '&::-webkit-scrollbar': {display: 'none'},
    }
}
